import { render, staticRenderFns } from "./GP4AM_parameters.vue?vue&type=template&id=6ea97f18&scoped=true&"
import script from "./GP4AM_parameters.vue?vue&type=script&lang=js&"
export * from "./GP4AM_parameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea97f18",
  null
  
)

export default component.exports